import {
  createContext,
  useEffect,
  useSyncExternalStore,
  type ReactNode,
} from "react";
import {
  applySentryScopeContext,
  clearSentryScopeContext,
} from "../sentry/identity";
import type { ScopeDbService } from "../ui-db/scope/runtime-types";
import type { CoworkingRuntime } from "./runtime-types";

const CoworkingRuntimeContext = createContext<CoworkingRuntime | null>(null);

function SentryScopeRuntimeBridge({ scopeDb }: { scopeDb: ScopeDbService }) {
  const scopeState = useSyncExternalStore(
    scopeDb.subscribe,
    scopeDb.getState,
    scopeDb.getState,
  );

  useEffect(() => {
    if (scopeState.data) {
      applySentryScopeContext(scopeState.data);
    } else {
      clearSentryScopeContext();
    }

    return () => {
      clearSentryScopeContext();
    };
  }, [scopeState.data]);

  return null;
}

function CoworkingRuntimeProvider({
  children,
  runtime,
}: {
  children: ReactNode;
  runtime: CoworkingRuntime;
}) {
  return (
    <CoworkingRuntimeContext.Provider value={runtime}>
      <SentryScopeRuntimeBridge scopeDb={runtime.scopeDb} />
      {children}
    </CoworkingRuntimeContext.Provider>
  );
}

export { CoworkingRuntimeContext, CoworkingRuntimeProvider };
